<template>
    <div class="w-views page-bang">
        <div class="content-wrapper">
            <div class="event-screen">
                <div class="event-details bang">
                    <div class="header">
                        <i class="back" @click="windowHistory.length >= 3 ? goBack() : goTo(`/clubs`)"></i>
                        <i class="dots" v-if="club && club.membership !== 'host' && profile.id" v-show="!reportMenuVisible" v-on:click="showReportMenu"></i>
                    </div>

                    <ClubDetails v-if="club" :clubId="clubId"/>

                    <div class="mobileSidebarHolder positionRight"
                        v-show="showReportMenu"
                        :class="{'active': reportMenuVisible}">
                        <div class="mobileSidebarHide" @click="hideReportMenu"></div>
                        <div class="mobileSidebar">

                            <div class="report-menu">
                                <div class="inner">
                                    <div class="title">{{ trans('events.report.title') }}</div>
                                    <div class="box">
                                        <div class="checkbox-container">
                                            <label class="checkbox-label">
                                                <input type="checkbox" name="wrong-type-event" value="wrong_category" v-model="reportData">
                                                <span class="checkbox-custom"></span>
                                                <div class="input-title">{{ trans('events.report.wrong_type') }}</div>
                                            </label>
                                        </div>
                                        <div class="checkbox-container">
                                            <label class="checkbox-label">
                                                <input type="checkbox" name="under-age" value="under_age" v-model="reportData">
                                                <span class="checkbox-custom"></span>
                                                <div class="input-title">{{ trans('report_under_age') }}</div>
                                            </label>
                                        </div>
                                        <div class="checkbox-container">
                                            <label class="checkbox-label">
                                                <input type="checkbox" name="illegal-event" value="illegal" v-model="reportData">
                                                <span class="checkbox-custom"></span>
                                                <div class="input-title">{{ trans('events.report.illegal') }}</div>
                                            </label>
                                        </div>
                                        <div class="checkbox-container">
                                            <label class="checkbox-label">
                                                <input type="checkbox" name="spam-event" value="spam" v-model="reportData">
                                                <span class="checkbox-custom"></span>
                                                <div class="input-title">{{ trans('report_spam') }}</div>
                                            </label>
                                        </div>
                                    </div>
                                    <button type="submit" class="btn" @click="sendClubReport">{{ trans('send') }}</button>
                                </div>
                            </div><!--report-menu-->

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex';

    import ClubDetails from "@clubs/views/widgets/club/Item.vue";
    import clubsModule from '@clubs/module/store/type'
    import chatModule from '@chat/module/store/type'

    export default {
        components: {
            ClubDetails
        },
        data() {
            return {
                menuVisible: false,
                reportMenuVisible: false,
                reportData: []
            }
        },
        props: ['clubId', 'nav'],
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-clubs').default,
        ],
        methods: {
            ...mapActions({
                setClub: clubsModule.actions.setClub,
                reportClub: clubsModule.actions.clubs.report,
                toggleClubLike: clubsModule.actions.clubs.like
            }),
            showReportMenu() {
                this.reportMenuVisible = true;
            },
            hideReportMenu() {
                this.reportMenuVisible = false;
            },
            closeFilter() {
                this.hideReportMenu();
            },
            sendClubReport() {
              this.reportClub({
                reason: this.reportData,
                id: this.clubId,
                callback: this.clubReportResponse,
              })
            },
            clubReportResponse(response) {
                if (response.data.success) {
                    this.showSuccessNotification(response.data.trans)
                } else {
                    this.showErrorNotification(response.data.trans)
                }
                this.closeFilter()
            },
            async chatClub() {
                if (!this.isMyClub(this.club)) {
                    this.goTo(`/chat/club/${this.clubId}`);
                } else {
                    this.goTo('/chat');
                }
            },
        },
        computed: {
            ...mapState({
                blockedUsersIds: state => state.blockedUsersIds,
                profile: 'profile'
            }),
            ...mapGetters({
                unreadEventMessagesCount: chatModule.getters.messages.count.unreadEvent
            }),
            heartFilledIn() {
                return this.club.isLiked
            },
            club() {
                return this.$store.getters.getClub(this.clubId)
            },
            windowHistory() {
                return window.history
            }
        },
        watch: {
            blockedUsersIds: function(blockedUsersIds) {
                if (blockedUsersIds.includes(this.club?.user_id)) {
                    this.goTo('/clubs')
                }
            }
        },
        mounted() {
          console.log('[Club Mobile Item] mounted')
          this.$store.commit('updateUser', { has_club_notifications: false })
          this.$store.dispatch(clubsModule.actions.clubs.loadInfo, {clubId:this.clubId,edit:0})
        },
        beforeMount() {
        },
        activated() {
              console.log('[Club Mobile Item] Activated')
        }
    }
</script>
